export const BrowserStorageKeys = {
    accessToken: 'accessToken',
    isCRMSignIn: 'isCRMSignIn',
    isWaitForSSOResponse: 'isWaitForSSOResponse',
    directUrl: 'directUrl',
    referrerUrl: 'referrerUrl',
    timezone: 'timezone',
    showMaintenanceModal: 'showMaintenanceModal',
};

/** IndexedDB database that holds the per-feature draft tables (see DraftStoreNameEnum). */
export const DRAFT_STORAGE_DB_NAME = 'drafts';

/** Drafts older than 1 month are removed when read or purged. */
export const DRAFT_EXPIRATION_MS = 30 * 24 * 60 * 60 * 1000;

/** Backend hash used for drafts of objects that do not exist on the backend yet (create pages). */
export const DRAFT_NEW_OBJECT_HASH = 'new';
